import { Modal } from 'react-bootstrap'
import { useEffect, useState } from 'react'
import { GET_OCR_KEY } from '../../../GraphQLQueries/querys'
import useApi from '../../../../../../hooks/useQuery'
import useMutationApi from '../../../../../../hooks/useMutation'
import { GEMINI_OCR_AI, UPLOAD_OCR_FILE } from '../../../GraphQLQueries/mutation'
import { LoadingSpinner } from '../../../../../../_ePulse/layout/components/LoadingSpinner'
import { toast } from 'react-toastify'

interface OcrAppSetting {
  __typename: string
  APP_OCR_AI: string
  AZURE_AI_SECRET_KEY: string
  AZURE_AI_FE_ENDPOINT: string
  BUSINESS_OCR_AI:string
  ENFORCE_APP_LEVEL_OCR:string
}

export const UploadImage = (props: any) => {
  const [fileName, setFileName] = useState('')
  const [isloading, setloading] = useState(false)
  const [apimKeys, setapimKeys] = useState<string | null>()
  const [errorMessage, setErrorMessage] = useState('')
  const [base64String, setBase64String] = useState('')
  const [dataForOCR, setDataForOCR] = useState<OcrAppSetting | null>()

  const { createData, loading, error, data } = useMutationApi(UPLOAD_OCR_FILE)

  const { createData: geminiCreateData, loading: geminiLoading, error: geminiError, data: geminiData } = useMutationApi(GEMINI_OCR_AI)

  const { data: OCRdata, loading: loadingdata, error: e } = useApi(true, GET_OCR_KEY, {})

  useEffect(() => {
    setDataForOCR(OCRdata?.getOCRKey)
  }, [OCRdata])



  const handleOnUpload = async () => {
    setloading(true)

    try {
      if (base64String === '') {
        throw new Error('Please Upload image')
      }
       const bodyData = {
          base64Source: base64String,
        }

      let ocrApi = '';
      let apimId ='';

      if(dataForOCR?.ENFORCE_APP_LEVEL_OCR){
         ocrApi =dataForOCR?.APP_OCR_AI;  
      }
      else {
         ocrApi = dataForOCR?.BUSINESS_OCR_AI ?? '';
      }


      // if (dataForOCR?.APP_OCR_AI === 'gemini')
      // // if(false)
      // {
      //   const data = await geminiCreateData({ baseUrl: base64String })
      //   const geminiData = data.data.extractGeminiPharmaInvoice;


      //   if (geminiData.orderDetail.length == 0) {
      //     throw new Error('Please Upload A Clear Image, Response Was Not Clear')
      //   }

      //   props.handleOCRMedicineData(geminiData);
      //   props.closeModal()
      //   setloading(false)
      // }
      if(ocrApi==='azure'){
         const requestBody = JSON.stringify(bodyData)
          const headers = {
          'Content-Type': 'application/json',
          'Ocp-Apim-Subscription-Key': dataForOCR!.AZURE_AI_SECRET_KEY,
        }

        const response = await fetch(dataForOCR!.AZURE_AI_FE_ENDPOINT, {
          method: 'POST',
          headers: headers,
          body: requestBody,
        })

        if (!response.ok) {
          throw new Error('Network response was not ok')
        }

         apimId = response.headers.get('apim-request-id') ??'';
        setapimKeys(apimId)
      }
        

      const data = await createData({ apimId: apimId, baseUrl:base64String?? "" })
        const uploadOcrFile = data.data?.uploadOcrFileV1


        if (uploadOcrFile.orderDetail.length == 0) {
          throw new Error('Please Upload A Clear Image, Response Was Not Clear')
        }




        props.handleOCRMedicineData(uploadOcrFile)
        props.closeModal()
        setloading(false)
    


    } catch (e) {
      if (e instanceof Error) {
        toast.error(e.message)
      } else {
        toast.error('An unknown error occurred.')
      }
    } finally {
      setloading(false)
    }
  }

  const handleFileChange = async (event: any) => {
    const file = event.target.files[0]
    setFileName(file.name)

    if (file) {
      const reader = new FileReader()

      reader.onloadend = () => {
        const base64 = reader.result as string
        setBase64String(base64?.replace(/^data:[^;]+;base64,/, ''))
      }
      reader.readAsDataURL(file)
    }
  }

  return (
    <>
      <LoadingSpinner isLoading={isloading} />
      <Modal
        show={props.modalState}
        dialogClassName='ePulse-modal ePulse-modal-50w'
        onHide={() => props.closeModal()}
        backdrop='static'
      >
        <Modal.Header className='border-0' closeButton>
          <span className='fs-3 fw-bold'>Upload</span>
        </Modal.Header>
        <Modal.Body className='container' />
        <div className='ePulse-modal-content'>
          <input
            type='file'
            id='upload'
            onChange={handleFileChange}
            hidden
            accept='.png, .jpg , .jpeg'
          />
          <label
            htmlFor='upload'
            className='ePulse-button3'
            style={{
              marginLeft: 16,
            }}
          >
            Choose File
          </label>
          <span>{fileName}</span>
          <div className='btn-row'>
            <button className='ePulse-btn-primary' type='button' onClick={handleOnUpload}>
              Upload
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}
